export const backendTopics = {
	export: 'export',
	global: 'global',
	tabMessage: 'tabMessage',
	apiProxy: 'apiProxy',
	linkedInProxy: 'linkedInProxy',
	linkedInProxyV2: 'linkedInProxyV2',
	linkedInProxyHeaders: 'linkedInProxyHeaders',
	linkedInService: 'linkedInService',
	linkedInVoyagerSpy: 'linkedInVoyagerSpy',
	linkedInHeadersRewriter: 'linkedInHeadersRewriter',
	salesNavigatorProxy: 'salesNavigatorProxy',
	salesNavigatorService: 'salesNavigatorService',
	salesNavigatorVoyagerSpy: 'salesNavigatorVoyagerSpy',
	oauth: 'oauth',
	logging: 'logging',
	traceableRequests: 'traceableRequests',
	scheduler: 'scheduler',
	exportContacts: 'exportContacts',
	system: 'system',
	settings: 'settings',
	localStorage: 'localStorage',
	reliability: 'reliability',
	campaignsRunner: 'campaignsRunner',
	offscreen: 'offscreen'
}
